import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Label from '../../../../../components/common-components/label/Label';
import Heading from '../../../../../components/common-components/heading/Heading';
import { HEADING } from '../../../../../components/common-components/heading/Constants';
import ButtonDropdown from '../../../../../components/common-components/buttonDropdown';
import Table from '../../../../Table/Index';
import MasterDeleteModel from '../master-allergy/MasterDeleteModel';
import { deleteMasterTestUnit, getMasterTestUnit } from './MasterTestUnitSaga';
import { componentKey, setOpenAddTestUnitModal } from './MasterTestUnitSlice';
import moment from 'moment';
import MasterEditTestUnitModel from './MasterEditTestUnitModel';
import MasterAddTestUnitModel from './MasterAddTestUnitModel';


function MasterTestUnit() {
    const { masterTestUnitData, isOpenAddTestUnitModal } = useSelector((state) => state[componentKey]);
    const dispatch = useDispatch();
    const [openEditModal, setOpenEditModal] = useState({ open: false, data: {} });
    const [openDeleteModal, setOpenDeleteModal] = useState({ open: false, data: {} });
    const [paginationState, setPaginationState] = useState({
        pageNumber:  1,
        limit: 10,
        totalRecords: masterTestUnitData?.data?.totalRecords ||  0,
    });

    useEffect(() => {
        setPaginationState((prevState) => ({
            ...prevState,
            totalRecords: masterTestUnitData?.data?.totalRecords || 0,
        }));
    }, [masterTestUnitData?.data?.totalRecords]);


    const role = localStorage.getItem('role')

    useEffect(() => {
        const payload = {
            page: paginationState?.pageNumber
        }
        dispatch(getMasterTestUnit(payload));
    }, [dispatch, paginationState?.pageNumber]);


    const finalDelete = (action) => {
        const payload = {
            id:  openDeleteModal?.data?.uuid,
            setOpenDeleteModal:setOpenDeleteModal
        }
        
        if (action === "yes") {
            dispatch(deleteMasterTestUnit(payload));
            return;
        }
        setOpenDeleteModal({ open: false, data: {} });
    };

    const columns = [
        {
            field: 'testName',
            label: <Label fontWeight="font-bold">Test Name</Label>,
            renderLogic: (row) => {
                return (
                    <>
                        <div>
                            <Heading fontWeight="bold" type={HEADING.H1} color="gray-500" fontSize={'md'}>
                                {row.testName || "-"}
                            </Heading>
                        </div>
                    </>
                );
            },
        },
        {
            field: 'unit',
            label: <Label fontWeight="font-bold">Unit</Label>,
            renderLogic: (row) => {
                return (
                    <>
                        <div>
                            <Heading type={HEADING.H1} color="gray-500" fontSize={'md'}>
                                {row.unit || "-"}
                            </Heading>
                        </div>
                    </>
                );
            },
        },
        {
            field: 'mainTest',
            label: <Label fontWeight="font-bold">Main Test</Label>,
            renderLogic: (row) => {
                return (
                    <>
                        <div>
                            <Heading type={HEADING.H1} color="gray-500" fontSize={'md'}>
                                {row.mainTest || "-"}
                            </Heading>
                        </div>
                    </>
                );
            },
        },
         {
            field: 'createdAt',
            label: <Label fontWeight="font-bold">Created At</Label>,
            renderLogic: (row) => {
                return (
                    <>
                        <div>
                            <Heading type={HEADING.H1} color="gray-500" fontSize={'md'}>
                                { row.created_at ? moment(row.created_at).format("YYYY-MM-DD hh:mm A") : <p className="text-center">-</p>}
                            </Heading>
                        </div>
                    </>
                );
            },
        },
         {
            field: 'updatedAt',
            label: <Label fontWeight="font-bold">Updated At</Label>,
            renderLogic: (row) => {
                return (
                    <>
                        <div>
                            <Heading type={HEADING.H1} color="gray-500" fontSize={'md'}>
                               { row.updated_at ? moment(row.updated_at).format("YYYY-MM-DD hh:mm A") : <p className="text-center">-</p>}
                            </Heading>
                        </div>
                    </>
                );
            },
        },
        {
            field: 'action',
            label: role !== 'Front Desk' && <Label fontWeight="font-bold">Action</Label>,
            renderLogic: (row) => {
                const handleEdit = (row) => {
                    setOpenEditModal({ open: true, data: row });
                  
                };

                const handleDelete = (row) => {
                    setOpenDeleteModal({ open: true, data: row });
                }
                
                return (
                    <>
                        {role !== 'Front Desk' && <div className="flex items-center">
                            <div>
                                <Heading type={HEADING.H1} color="gray-500" fontSize={'md'}>{row.action}</Heading>
                            </div>
                            <ButtonDropdown
                                customBtnClass="p-0"
                                endIcon="moreVertIcon"
                                options={[
                                    { label: 'Edit', value: 'Edit' },
                                    // { label: 'View', value: 'View' },
                                    { label: 'Delete', value: 'Delete' },
                                ]}
                                selectCb={(option) => {
                                    switch (option.value) {
                                        case 'Edit':
                                            handleEdit(row);
                                            break;
                                        case 'Delete':
                                            handleDelete(row);
                                            break;
                                        default:
                                            break;
                                    }
                                }}
                            />
                        </div>}
                    </>
                );
            },
        },
    ];
    return (
        <div>
            <div className='pb-[30px]'>
                <Table isPagination={false} coloumns={columns} rows={masterTestUnitData?.data?.test_units}
                   paginationProps={{
                    isPagination: true,
                    totalCount: paginationState?.totalRecords,
                    limit: paginationState?.limit,
                    onPageChange: (page) => {
                        setPaginationState((prev) => ({
                            ...prev,
                            pageNumber: page,
                        }));
                    },
                }}                 
                 />
            </div>
            {openEditModal?.open &&<MasterEditTestUnitModel data={openEditModal?.data} open={openEditModal?.open} close={()=>{setOpenEditModal({open:false,data:{}})}} />}
            {openDeleteModal?.open && <MasterDeleteModel open={openDeleteModal?.open} message={"test unit"} close={(action) =>  finalDelete(action)} />}
            {isOpenAddTestUnitModal && (
                <MasterAddTestUnitModel
                    data={null}
                    open={isOpenAddTestUnitModal}
                    close={() => dispatch(setOpenAddTestUnitModal(false))}
                />
            )}
        </div>
    );
}

export default MasterTestUnit; 